
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1601Dialog extends Serenity.EntityDialog<Report_1601Row, any> {
        protected getFormKey() { return Report_1601Form.formKey; }
        protected getIdProperty() { return Report_1601Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1601Row.localTextPrefix; }
        protected getNameProperty() { return Report_1601Row.nameProperty; }
        protected getService() { return Report_1601Service.baseUrl; }
        protected getDeletePermission() { return Report_1601Row.deletePermission; }
        protected getInsertPermission() { return Report_1601Row.insertPermission; }
        protected getUpdatePermission() { return Report_1601Row.updatePermission; }

        protected form = new Report_1601Form(this.idPrefix);

    }
}